/**
 * Builds the ordered onboarding flow from config — no hardcoded steps. Disabled steps simply don't
 * appear. The interview itself is always the final step.
 */
export const STEP = {
  PERMISSION: 'permission',
  VERIFICATION: 'verification',
  INSTRUCTION: 'instruction',
  INTERVIEW: 'interview',
};

export const STEP_LABEL = {
  [STEP.PERMISSION]: 'Permissions',
  [STEP.VERIFICATION]: 'Verification',
  [STEP.INSTRUCTION]: 'Instructions',
  [STEP.INTERVIEW]: 'Interview',
};

export function buildFlow(config) {
  const s = (config && config.steps) || {};
  const steps = [];
  if (s.permission) steps.push(STEP.PERMISSION);
  if (s.verification) steps.push(STEP.VERIFICATION);
  if (s.instruction) steps.push(STEP.INSTRUCTION);
  steps.push(STEP.INTERVIEW);
  return steps;
}
